module.exports = __webpack_public_path__ + "img/S2SByConverge.8aab940b.png";